/**
 * @file
 * A JavaScript file for Anchor Platform logged in user.
 *
 */

"use strict";

var
	delay = 500,
	isLoading = false,
	isDone = true,
	modal,
	unCodes,
	hsCodes,
	shippingLine,
	releaseDepots,
	filters = [];

(function($, Drupal) {

	$(document).ready(function() {
		hamburger();
		modalOpen();
		// expander();

		$('input.custom-autocomplete').on('keyup', function(e) {
			var searchField = this;

			if (e.which == 40 || e.which == 38) return key_scroll();

			if (!isLoading) {

				var p = $(searchField).val();

				if (e.which == 27) {
					$(populate_list).parent().hide();
					$(searchField).val('');
				} else if (p.length >= 1) {
					isLoading = true;

					setTimeout(function() {
						isLoading = false;
						isDone = false;
						isLoading = false;
						one_stop_filter('autocomplete', searchField);

					}, delay);
				} else if (p.length < 1) {
					isLoading = false;
				}
			}
		});

		$('.customer-select').find('select').change(function(e) {
			one_stop_filter('customer_change', this);
		});

		$('#edit-field-shipping-line-code-booking-und-0-value').change(function(e) {
			var shippingvalue = this;
			setTimeout(function() {
				one_stop_filter('selectshippingline', shippingvalue);
			}, delay );
		});
	});


	window.one_stop_filter = function(method, el) {

		if (method == 'autocomplete') {
			var value = el.value;

			add_filter(el.dataset.filter, value);

			var obj = {};
			obj.value = value;
			obj.filters = JSON.stringify(filters);
			obj.filter = el.dataset.filter;
			obj.method = method;
		}

		if (method == 'customer_change') {
			var value = el.value;

			var obj = {};
			obj.value = value;
			obj.method = method;
		}

		if (method == 'selectshippingline') {
			var value = el.value;

			var obj = {};
			obj.value = value;
			obj.method = method;
		}

		$().customAjax({
			TYPE: "POST",
			AJAX_URL: Drupal.settings.basePath + "1stop/api",
			POST_STRING: obj,

			onLoad: function() {},

			beforeSend: function() {},

			success: function(data) {

				if (data.success) {

					// AUTO COMPLETE
					if (typeof data.autocomplete !== 'undefined') {
						populate_auto_complete_list(data, el);
					}

					// Customer change
					if (typeof data.customer_change !== 'undefined') {
						$('#edit-field-customer-who-receives-book').find('.form-checkboxes').html(data.customer_change);
					}

					// Select shipping line
					if (typeof data.selectshippingline !== 'undefined') {
						$('#edit-field-shipping-line-und-0-value').val(data.selectshippingline[0]['description']);
					}
				}

				if (data.error) {
					alert(data.error);
				}
			},

			onEmpty: function() {},

			error: function(data) {}

		});
	}

	window.populate_auto_complete_list = function(data, el) {

		var elwidth = $(el).innerWidth();
		var elheight = $(el).innerHeight();
		var elposition = $(el).position();
		var eltop = elposition.top + elheight;

		var html = '<div id="autocomplete" style="width: ' + elwidth + 'px; top: ' + eltop + 'px;"><ul class="autocomplete-list">';

		data.success.forEach(function(list, i) {
			var filter = data.filter
			html += '<li tabindex="' + i + '" ><a class="PopulatedList" href="#" >' + list[filter] + '</a></li>';
		});

		html += '</ul></div>';

		$('#autocomplete').remove();

		$(el).after(html);

		$('.PopulatedList').click(function(e) {
			$('#autocomplete ul').html('');
			$('#autocomplete ul').parent().hide();
			$('#autocomplete').prev().val($(this).text());
			add_filter(data.filter, $(this).text());
		});
	}


	window.key_scroll = function() {
		var populate_list = $('.autocomplete-list');

		$(populate_list).on('focus', 'li', function() {
			$(this).addClass('hover-state').siblings().removeClass();
			$(this).closest(populate_list).scrollTop($(this).index() * $(this).outerHeight());

		}).on('keydown', 'li', function(e) {
			if (e.keyCode == 40) {
				$(this).next().focus();
				return false;

			} else if (e.keyCode == 38) {
				$(this).prev().focus();
				return false;
			}

			if (e.keyCode == 13) {
				$(this).children().click();
			}
		}).find('li').first().focus();
	}


	function add_filter(name, value) {
		if( filters.length > 0 ) {

			var exists = false;

			filters.forEach( function(f,i){
				if( f.filter == name ) {
					f.value = value;
					exists = true;
				}
			});

			if( !exists ) {
				filters.push({ filter: name, value: value });
			}
		}
		else{
			filters.push({ filter: name, value: value });
		}
	}

	function hamburger() {
		$(window).resize(function() {
			var more = document.getElementById("js-navigation-more");
			if ($(more).length > 0) {
				var windowWidth = $(window).width();
				var moreLeftSideToPageLeftSide = $(more).offset().left;
				var moreLeftSideToPageRightSide = windowWidth - moreLeftSideToPageLeftSide;

				if (moreLeftSideToPageRightSide < 330) {
					$("#js-navigation-more .submenu .submenu").removeClass("fly-out-right");
					$("#js-navigation-more .submenu .submenu").addClass("fly-out-left");
				}

				if (moreLeftSideToPageRightSide > 330) {
					$("#js-navigation-more .submenu .submenu").removeClass("fly-out-left");
					$("#js-navigation-more .submenu .submenu").addClass("fly-out-right");
				}
			}
		});

		var menuToggle = $("#js-mobile-menu").unbind();

		menuToggle.on("click", function(e) {
			e.preventDefault();
			$("nav#main-menu").toggleClass('show');
		});
	}

	function modalOpen() {

		// Triggers UN Codes

		// $(".js--add-new-uncode").on("click", function(e) {
		// 	if (!$("body").hasClass("modal-open")) {
		// 		e.preventDefault();
		// 		modal(this, unCodes.addUnCodesHTML($(this).data()), unCodes.addUnCodes, {
		// 			action: $(this).data('action'),
		// 		});
		// 		$("body").addClass("modal-open");
		// 	} else {
		// 		$("body").removeClass("modal-open");
		// 	}
		// });

		// $(".js--edit-uncode").on("click", function(e) {
		// 	if (!$("body").hasClass("modal-open")) {
		// 		e.preventDefault();
		// 		modal(this, unCodes.editUnCodesHTML($(this).data()), unCodes.editUnCodes, {
		// 			action: $(this).data('action'),
		// 			tid: $(this).data('tid'),
		// 			autofire : true,
		// 		});
		// 		$("body").addClass("modal-open");
		// 	} else {
		// 		$("body").removeClass("modal-open");
		// 	}
		// });

		// $(".js--delete-uncode").on("click", function(e) {
		// 	if (!$("body").hasClass("modal-open")) {
		// 		e.preventDefault();
		// 		modal(this, unCodes.deleteUnCodesHTML($(this).data()), unCodes.deleteUnCodes, {
		// 			action: $(this).data('action'),
		// 			tid: $(this).data('tid'),
		// 		});
		// 		$("body").addClass("modal-open");
		// 	} else {
		// 		$("body").removeClass("modal-open");
		// 	}
		// });

		//  Triggers HS Codes

		// $(".js--add-new-hscode").on("click", function(e) {
		// 	if (!$("body").hasClass("modal-open")) {
		// 		e.preventDefault();
		// 		modal(this, hsCodes.addHsCodesHTML($(this).data()), hsCodes.addHsCodes, {
		// 			action: $(this).data('action'),
		// 		});
		// 		$("body").addClass("modal-open");
		// 	} else {
		// 		$("body").removeClass("modal-open");
		// 	}
		// });

		// $(".js--edit-hscode").on("click", function(e) {
		// 	if (!$("body").hasClass("modal-open")) {
		// 		e.preventDefault();
		// 		modal(this, hsCodes.editHsCodesHTML($(this).data()), hsCodes.editHsCodes, {
		// 			action: $(this).data('action'),
		// 			tid: $(this).data('tid'),
		// 			autofire : true,
		// 		});
		// 		$("body").addClass("modal-open");
		// 	} else {
		// 		$("body").removeClass("modal-open");
		// 	}
		// });

		// $(".js--delete-hscode").on("click", function(e) {
		// 	if (!$("body").hasClass("modal-open")) {
		// 		e.preventDefault();
		// 		modal(this, hsCodes.deleteHsCodesHTML($(this).data()), hsCodes.deleteHsCodes, {
		// 			action: $(this).data('action'),
		// 			tid: $(this).data('tid')
		// 		});
		// 		$("body").addClass("modal-open");
		// 	} else {
		// 		$("body").removeClass("modal-open");
		// 	}
		// });

		// triggers Shipping line

		// $(".js--add-new-shippingline").on("click", function(e) {
		// 	if (!$("body").hasClass("modal-open")) {
		// 		e.preventDefault();
		// 		modal(this, shippingLine.addShippingLineHTML($(this).data()), shippingLine.addShippingLine, {
		// 			action: $(this).data('action'),
		// 		});
		// 		$("body").addClass("modal-open");
		// 	} else {
		// 		$("body").removeClass("modal-open");
		// 	}
		// });

		// $(".js--edit-shippingline").on("click", function(e) {
		// 	if (!$("body").hasClass("modal-open")) {
		// 		e.preventDefault();
		// 		modal(this, shippingLine.editShippingLineHTML($(this).data()), shippingLine.editShippingLine, {
		// 			action: $(this).data('action'),
		// 			tid: $(this).data('tid'),
		// 			autofire : true,
		// 		});
		// 		$("body").addClass("modal-open");
		// 	} else {
		// 		$("body").removeClass("modal-open");
		// 	}
		// });

		// $(".js--delete-shippingline").on("click", function(e) {
		// 	if (!$("body").hasClass("modal-open")) {
		// 		e.preventDefault();
		// 		modal(this, shippingLine.deleteShippingLineHTML($(this).data()), shippingLine.deleteShippingLine, {
		// 			action: $(this).data('action'),
		// 			tid: $(this).data('tid'),
		// 		});
		// 		$("body").addClass("modal-open");
		// 	} else {
		// 		$("body").removeClass("modal-open");
		// 	}
		// });

		// Triggers Release Depots

		// $(".js--add-new-releasedepots").on("click", function(e) {
		// 	if (!$("body").hasClass("modal-open")) {
		// 		e.preventDefault();
		// 		modal(this, releaseDepots.addReleaseDepotsHTML($(this).data()), releaseDepots.addReleaseDepots, {
		// 			action: $(this).data('action'),
		// 		});
		// 		$("body").addClass("modal-open");
		// 	} else {
		// 		$("body").removeClass("modal-open");
		// 	}
		// });

		// $(".js--edit-releasedepots").on("click", function(e) {
		// 	if (!$("body").hasClass("modal-open")) {
		// 		e.preventDefault();
		// 		modal(this, releaseDepots.editReleaseDepotsHTML($(this).data()), releaseDepots.editReleaseDepots, {
		// 			action: $(this).data('action'),
		// 			tid: $(this).data('tid'),
		// 			autofire : true,
		// 		});
		// 		$("body").addClass("modal-open");
		// 	} else {
		// 		$("body").removeClass("modal-open");
		// 	}
		// });

		// $(".js--delete-releasedepots").on("click", function(e) {
		// 	if (!$("body").hasClass("modal-open")) {
		// 		e.preventDefault();
		// 		modal(this, releaseDepots.deleteReleaseDepotsHTML($(this).data()), releaseDepots.deleteReleaseDepots, {
		// 			action: $(this).data('action'),
		// 			tid: $(this).data('tid'),
		// 		});
		// 		$("body").addClass("modal-open");
		// 	} else {
		// 		$("body").removeClass("modal-open");
		// 	}
		// });

		$(".modal-fade-screen, .modal-close").on("click", function() {
			$("body").removeClass("modal-open");
		});

		$(".modal-inner").on("click", function(e) {
			e.stopPropagation();
		});

	}

	// function expander() {
	// 	$('.expander-trigger').click(function(){
	// 		$(this).toggleClass("expander-hidden");
	// 	});
	// }

	/**
	* Anchor Modal Popup
	**/
	window.modal = function(elem, html, callback, args) {
		$(theModal).unbind();
		var theModal = $("#anchorModal");
		$('.modal-content').html(html.output);

		if (args.autofire !== undefined) {
			if (typeof callback === 'function') {
				callback(theModal.dataset, args);
			}
			return;
		}

		$('#modal-btn-cancel').click( function(e) {
			e.preventDefault();
			$('#anchorModal').find('.modal-close').click();
		});

		$(theModal).find('#'+html.btn_id).click(function(e) {
			e.preventDefault();
			if (typeof callback === 'function') {
				callback(theModal.dataset, args);
			}
		});
	}

	window.disable_button = function(el, disable) {
		if( disable ) {
			el.setAttribute('disabled', true);
			el.classList.add('disabled');
		}
		else{
			el.removeAttribute('disabled', false);
			el.classList.remove('disabled');
		}
	}

	window.unCodes = {
		addUnCodesHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Add new port</h2>';
				html += '<p id="modal-error"></p>';
				html += '<div class="input-wrapper form-item">';
				html += '<label for="port-code">Port code <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="port-code" class="form-text">';
				html += '<label for="port-name">Port name <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="port-name" class="form-text">';
				html += '<label for="port-country">Port country <span class="form-required" title="This field is required.">*</span></label>';
				html += '<select id="port-country" name="field_port_country" class="form-select"><option value="_none">- None -</option><option value="AF">Afghanistan</option><option value="AX">Aland Islands</option><option value="AL">Albania</option><option value="DZ">Algeria</option><option value="AS">American Samoa</option><option value="AD">Andorra</option><option value="AO">Angola</option><option value="AI">Anguilla</option><option value="AQ">Antarctica</option><option value="AG">Antigua and Barbuda</option><option value="AR">Argentina</option><option value="AM">Armenia</option><option value="AW">Aruba</option><option value="AU">Australia</option><option value="AT">Austria</option><option value="AZ">Azerbaijan</option><option value="BS">Bahamas</option><option value="BH">Bahrain</option><option value="BD">Bangladesh</option><option value="BB">Barbados</option><option value="BY">Belarus</option><option value="BE">Belgium</option><option value="BZ">Belize</option><option value="BJ">Benin</option><option value="BM">Bermuda</option><option value="BT">Bhutan</option><option value="BO">Bolivia</option><option value="BA">Bosnia and Herzegovina</option><option value="BW">Botswana</option><option value="BV">Bouvet Island</option><option value="BR">Brazil</option><option value="IO">British Indian Ocean Territory</option><option value="VG">British Virgin Islands</option><option value="BN">Brunei</option><option value="BG">Bulgaria</option><option value="BF">Burkina Faso</option><option value="BI">Burundi</option><option value="KH">Cambodia</option><option value="CM">Cameroon</option><option value="CA">Canada</option><option value="CV">Cape Verde</option><option value="BQ">Caribbean Netherlands</option><option value="KY">Cayman Islands</option><option value="CF">Central African Republic</option><option value="TD">Chad</option><option value="CL">Chile</option><option value="CN">China</option><option value="CX">Christmas Island</option><option value="CC">Cocos (Keeling) Islands</option><option value="CO">Colombia</option><option value="KM">Comoros</option><option value="CG">Congo (Brazzaville)</option><option value="CD">Congo (Kinshasa)</option><option value="CK">Cook Islands</option><option value="CR">Costa Rica</option><option value="HR">Croatia</option><option value="CU">Cuba</option><option value="CW">Curaçao</option><option value="CY">Cyprus</option><option value="CZ">Czech Republic</option><option value="DK">Denmark</option><option value="DJ">Djibouti</option><option value="DM">Dominica</option><option value="DO">Dominican Republic</option><option value="EC">Ecuador</option><option value="EG">Egypt</option><option value="SV">El Salvador</option><option value="GQ">Equatorial Guinea</option><option value="ER">Eritrea</option><option value="EE">Estonia</option><option value="ET">Ethiopia</option><option value="FK">Falkland Islands</option><option value="FO">Faroe Islands</option><option value="FJ">Fiji</option><option value="FI">Finland</option><option value="FR">France</option><option value="GF">French Guiana</option><option value="PF">French Polynesia</option><option value="TF">French Southern Territories</option><option value="GA">Gabon</option><option value="GM">Gambia</option><option value="GE">Georgia</option><option value="DE">Germany</option><option value="GH">Ghana</option><option value="GI">Gibraltar</option><option value="GR">Greece</option><option value="GL">Greenland</option><option value="GD">Grenada</option><option value="GP">Guadeloupe</option><option value="GU">Guam</option><option value="GT">Guatemala</option><option value="GG">Guernsey</option><option value="GN">Guinea</option><option value="GW">Guinea-Bissau</option><option value="GY">Guyana</option><option value="HT">Haiti</option><option value="HM">Heard Island and McDonald Islands</option><option value="HN">Honduras</option><option value="HK">Hong Kong S.A.R., China</option><option value="HU">Hungary</option><option value="IS">Iceland</option><option value="IN">India</option><option value="ID">Indonesia</option><option value="IR">Iran</option><option value="IQ">Iraq</option><option value="IE">Ireland</option><option value="IM">Isle of Man</option><option value="IL">Israel</option><option value="IT">Italy</option><option value="CI">Ivory Coast</option><option value="JM">Jamaica</option><option value="JP">Japan</option><option value="JE">Jersey</option><option value="JO">Jordan</option><option value="KZ">Kazakhstan</option><option value="KE">Kenya</option><option value="KI">Kiribati</option><option value="KW">Kuwait</option><option value="KG">Kyrgyzstan</option><option value="LA">Laos</option><option value="LV">Latvia</option><option value="LB">Lebanon</option><option value="LS">Lesotho</option><option value="LR">Liberia</option><option value="LY">Libya</option><option value="LI">Liechtenstein</option><option value="LT">Lithuania</option><option value="LU">Luxembourg</option><option value="MO">Macao S.A.R., China</option><option value="MK">Macedonia</option><option value="MG">Madagascar</option><option value="MW">Malawi</option><option value="MY">Malaysia</option><option value="MV">Maldives</option><option value="ML">Mali</option><option value="MT">Malta</option><option value="MH">Marshall Islands</option><option value="MQ">Martinique</option><option value="MR">Mauritania</option><option value="MU">Mauritius</option><option value="YT">Mayotte</option><option value="MX">Mexico</option><option value="FM">Micronesia</option><option value="MD">Moldova</option><option value="MC">Monaco</option><option value="MN">Mongolia</option><option value="ME">Montenegro</option><option value="MS">Montserrat</option><option value="MA">Morocco</option><option value="MZ">Mozambique</option><option value="MM">Myanmar</option><option value="NA">Namibia</option><option value="NR">Nauru</option><option value="NP">Nepal</option><option value="NL">Netherlands</option><option value="AN">Netherlands Antilles</option><option value="NC">New Caledonia</option><option value="NZ">New Zealand</option><option value="NI">Nicaragua</option><option value="NE">Niger</option><option value="NG">Nigeria</option><option value="NU">Niue</option><option value="NF">Norfolk Island</option><option value="MP">Northern Mariana Islands</option><option value="KP">North Korea</option><option value="NO">Norway</option><option value="OM">Oman</option><option value="PK">Pakistan</option><option value="PW">Palau</option><option value="PS">Palestinian Territory</option><option value="PA">Panama</option><option value="PG">Papua New Guinea</option><option value="PY">Paraguay</option><option value="PE">Peru</option><option value="PH">Philippines</option><option value="PN">Pitcairn</option><option value="PL">Poland</option><option value="PT">Portugal</option><option value="PR">Puerto Rico</option><option value="QA">Qatar</option><option value="RE">Reunion</option><option value="RO">Romania</option><option value="RU">Russia</option><option value="RW">Rwanda</option><option value="BL">Saint Barthélemy</option><option value="SH">Saint Helena</option><option value="KN">Saint Kitts and Nevis</option><option value="LC">Saint Lucia</option><option value="MF">Saint Martin (French part)</option><option value="PM">Saint Pierre and Miquelon</option><option value="VC">Saint Vincent and the Grenadines</option><option value="WS">Samoa</option><option value="SM">San Marino</option><option value="ST">Sao Tome and Principe</option><option value="SA">Saudi Arabia</option><option value="SN">Senegal</option><option value="RS">Serbia</option><option value="SC">Seychelles</option><option value="SL">Sierra Leone</option><option value="SG">Singapore</option><option value="SX">Sint Maarten</option><option value="SK">Slovakia</option><option value="SI">Slovenia</option><option value="SB">Solomon Islands</option><option value="SO">Somalia</option><option value="ZA">South Africa</option><option value="GS">South Georgia and the South Sandwich Islands</option><option value="KR">South Korea</option><option value="SS">South Sudan</option><option value="ES">Spain</option><option value="LK">Sri Lanka</option><option value="SD">Sudan</option><option value="SR">Suriname</option><option value="SJ">Svalbard and Jan Mayen</option><option value="SZ">Swaziland</option><option value="SE">Sweden</option><option value="CH">Switzerland</option><option value="SY">Syria</option><option value="TW">Taiwan</option><option value="TJ">Tajikistan</option><option value="TZ">Tanzania</option><option value="TH">Thailand</option><option value="TL">Timor-Leste</option><option value="TG">Togo</option><option value="TK">Tokelau</option><option value="TO">Tonga</option><option value="TT">Trinidad and Tobago</option><option value="TN">Tunisia</option><option value="TR">Turkey</option><option value="TM">Turkmenistan</option><option value="TC">Turks and Caicos Islands</option><option value="TV">Tuvalu</option><option value="VI">U.S. Virgin Islands</option><option value="UG">Uganda</option><option value="UA">Ukraine</option><option value="AE">United Arab Emirates</option><option value="GB">United Kingdom</option><option value="US">United States</option><option value="UM">United States Minor Outlying Islands</option><option value="UY">Uruguay</option><option value="UZ">Uzbekistan</option><option value="VU">Vanuatu</option><option value="VA">Vatican</option><option value="VE">Venezuela</option><option value="VN">Vietnam</option><option value="WF">Wallis and Futuna</option><option value="EH">Western Sahara</option><option value="YE">Yemen</option><option value="ZM">Zambia</option><option value="ZW">Zimbabwe</option></select>';
				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Add</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		editUnCodesHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Update</h2>';
				html += '<p id="modal-error"></p>';
				html += '<div class="input-wrapper form-item">';
				html += '<label for="port-code">Port code <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="port-code" class="form-text">';
				html += '<label for="port-name">Port name <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="port-name" class="form-text">';
				html += '<label for="port-country">Port country <span class="form-required" title="This field is required.">*</span></label>';
				html += '<select id="port-country" name="field_port_country" class="form-select"><option value="_none">- None -</option><option value="AF">Afghanistan</option><option value="AX">Aland Islands</option><option value="AL">Albania</option><option value="DZ">Algeria</option><option value="AS">American Samoa</option><option value="AD">Andorra</option><option value="AO">Angola</option><option value="AI">Anguilla</option><option value="AQ">Antarctica</option><option value="AG">Antigua and Barbuda</option><option value="AR">Argentina</option><option value="AM">Armenia</option><option value="AW">Aruba</option><option value="AU">Australia</option><option value="AT">Austria</option><option value="AZ">Azerbaijan</option><option value="BS">Bahamas</option><option value="BH">Bahrain</option><option value="BD">Bangladesh</option><option value="BB">Barbados</option><option value="BY">Belarus</option><option value="BE">Belgium</option><option value="BZ">Belize</option><option value="BJ">Benin</option><option value="BM">Bermuda</option><option value="BT">Bhutan</option><option value="BO">Bolivia</option><option value="BA">Bosnia and Herzegovina</option><option value="BW">Botswana</option><option value="BV">Bouvet Island</option><option value="BR">Brazil</option><option value="IO">British Indian Ocean Territory</option><option value="VG">British Virgin Islands</option><option value="BN">Brunei</option><option value="BG">Bulgaria</option><option value="BF">Burkina Faso</option><option value="BI">Burundi</option><option value="KH">Cambodia</option><option value="CM">Cameroon</option><option value="CA">Canada</option><option value="CV">Cape Verde</option><option value="BQ">Caribbean Netherlands</option><option value="KY">Cayman Islands</option><option value="CF">Central African Republic</option><option value="TD">Chad</option><option value="CL">Chile</option><option value="CN">China</option><option value="CX">Christmas Island</option><option value="CC">Cocos (Keeling) Islands</option><option value="CO">Colombia</option><option value="KM">Comoros</option><option value="CG">Congo (Brazzaville)</option><option value="CD">Congo (Kinshasa)</option><option value="CK">Cook Islands</option><option value="CR">Costa Rica</option><option value="HR">Croatia</option><option value="CU">Cuba</option><option value="CW">Curaçao</option><option value="CY">Cyprus</option><option value="CZ">Czech Republic</option><option value="DK">Denmark</option><option value="DJ">Djibouti</option><option value="DM">Dominica</option><option value="DO">Dominican Republic</option><option value="EC">Ecuador</option><option value="EG">Egypt</option><option value="SV">El Salvador</option><option value="GQ">Equatorial Guinea</option><option value="ER">Eritrea</option><option value="EE">Estonia</option><option value="ET">Ethiopia</option><option value="FK">Falkland Islands</option><option value="FO">Faroe Islands</option><option value="FJ">Fiji</option><option value="FI">Finland</option><option value="FR">France</option><option value="GF">French Guiana</option><option value="PF">French Polynesia</option><option value="TF">French Southern Territories</option><option value="GA">Gabon</option><option value="GM">Gambia</option><option value="GE">Georgia</option><option value="DE">Germany</option><option value="GH">Ghana</option><option value="GI">Gibraltar</option><option value="GR">Greece</option><option value="GL">Greenland</option><option value="GD">Grenada</option><option value="GP">Guadeloupe</option><option value="GU">Guam</option><option value="GT">Guatemala</option><option value="GG">Guernsey</option><option value="GN">Guinea</option><option value="GW">Guinea-Bissau</option><option value="GY">Guyana</option><option value="HT">Haiti</option><option value="HM">Heard Island and McDonald Islands</option><option value="HN">Honduras</option><option value="HK">Hong Kong S.A.R., China</option><option value="HU">Hungary</option><option value="IS">Iceland</option><option value="IN">India</option><option value="ID">Indonesia</option><option value="IR">Iran</option><option value="IQ">Iraq</option><option value="IE">Ireland</option><option value="IM">Isle of Man</option><option value="IL">Israel</option><option value="IT">Italy</option><option value="CI">Ivory Coast</option><option value="JM">Jamaica</option><option value="JP">Japan</option><option value="JE">Jersey</option><option value="JO">Jordan</option><option value="KZ">Kazakhstan</option><option value="KE">Kenya</option><option value="KI">Kiribati</option><option value="KW">Kuwait</option><option value="KG">Kyrgyzstan</option><option value="LA">Laos</option><option value="LV">Latvia</option><option value="LB">Lebanon</option><option value="LS">Lesotho</option><option value="LR">Liberia</option><option value="LY">Libya</option><option value="LI">Liechtenstein</option><option value="LT">Lithuania</option><option value="LU">Luxembourg</option><option value="MO">Macao S.A.R., China</option><option value="MK">Macedonia</option><option value="MG">Madagascar</option><option value="MW">Malawi</option><option value="MY">Malaysia</option><option value="MV">Maldives</option><option value="ML">Mali</option><option value="MT">Malta</option><option value="MH">Marshall Islands</option><option value="MQ">Martinique</option><option value="MR">Mauritania</option><option value="MU">Mauritius</option><option value="YT">Mayotte</option><option value="MX">Mexico</option><option value="FM">Micronesia</option><option value="MD">Moldova</option><option value="MC">Monaco</option><option value="MN">Mongolia</option><option value="ME">Montenegro</option><option value="MS">Montserrat</option><option value="MA">Morocco</option><option value="MZ">Mozambique</option><option value="MM">Myanmar</option><option value="NA">Namibia</option><option value="NR">Nauru</option><option value="NP">Nepal</option><option value="NL">Netherlands</option><option value="AN">Netherlands Antilles</option><option value="NC">New Caledonia</option><option value="NZ">New Zealand</option><option value="NI">Nicaragua</option><option value="NE">Niger</option><option value="NG">Nigeria</option><option value="NU">Niue</option><option value="NF">Norfolk Island</option><option value="MP">Northern Mariana Islands</option><option value="KP">North Korea</option><option value="NO">Norway</option><option value="OM">Oman</option><option value="PK">Pakistan</option><option value="PW">Palau</option><option value="PS">Palestinian Territory</option><option value="PA">Panama</option><option value="PG">Papua New Guinea</option><option value="PY">Paraguay</option><option value="PE">Peru</option><option value="PH">Philippines</option><option value="PN">Pitcairn</option><option value="PL">Poland</option><option value="PT">Portugal</option><option value="PR">Puerto Rico</option><option value="QA">Qatar</option><option value="RE">Reunion</option><option value="RO">Romania</option><option value="RU">Russia</option><option value="RW">Rwanda</option><option value="BL">Saint Barthélemy</option><option value="SH">Saint Helena</option><option value="KN">Saint Kitts and Nevis</option><option value="LC">Saint Lucia</option><option value="MF">Saint Martin (French part)</option><option value="PM">Saint Pierre and Miquelon</option><option value="VC">Saint Vincent and the Grenadines</option><option value="WS">Samoa</option><option value="SM">San Marino</option><option value="ST">Sao Tome and Principe</option><option value="SA">Saudi Arabia</option><option value="SN">Senegal</option><option value="RS">Serbia</option><option value="SC">Seychelles</option><option value="SL">Sierra Leone</option><option value="SG">Singapore</option><option value="SX">Sint Maarten</option><option value="SK">Slovakia</option><option value="SI">Slovenia</option><option value="SB">Solomon Islands</option><option value="SO">Somalia</option><option value="ZA">South Africa</option><option value="GS">South Georgia and the South Sandwich Islands</option><option value="KR">South Korea</option><option value="SS">South Sudan</option><option value="ES">Spain</option><option value="LK">Sri Lanka</option><option value="SD">Sudan</option><option value="SR">Suriname</option><option value="SJ">Svalbard and Jan Mayen</option><option value="SZ">Swaziland</option><option value="SE">Sweden</option><option value="CH">Switzerland</option><option value="SY">Syria</option><option value="TW">Taiwan</option><option value="TJ">Tajikistan</option><option value="TZ">Tanzania</option><option value="TH">Thailand</option><option value="TL">Timor-Leste</option><option value="TG">Togo</option><option value="TK">Tokelau</option><option value="TO">Tonga</option><option value="TT">Trinidad and Tobago</option><option value="TN">Tunisia</option><option value="TR">Turkey</option><option value="TM">Turkmenistan</option><option value="TC">Turks and Caicos Islands</option><option value="TV">Tuvalu</option><option value="VI">U.S. Virgin Islands</option><option value="UG">Uganda</option><option value="UA">Ukraine</option><option value="AE">United Arab Emirates</option><option value="GB">United Kingdom</option><option value="US">United States</option><option value="UM">United States Minor Outlying Islands</option><option value="UY">Uruguay</option><option value="UZ">Uzbekistan</option><option value="VU">Vanuatu</option><option value="VA">Vatican</option><option value="VE">Venezuela</option><option value="VN">Vietnam</option><option value="WF">Wallis and Futuna</option><option value="EH">Western Sahara</option><option value="YE">Yemen</option><option value="ZM">Zambia</option><option value="ZW">Zimbabwe</option></select>';
				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Update</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		deleteUnCodesHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Delete port</h2>';
				html += '<p id="modal-error"></p>';
				html += '<p>Are you sure you want to delete this port?</p>';
				html += '<button id="modal-btn-cancel" class="btn">Cancel</button>';
				html += '<button id="modal-btn-cta" class="btn">Delete</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		errorHTML: function(error, level) {
            var errorElem = document.getElementById('modal-error');
                if(null == errorElem){ return; }

                errorElem.innerHTML = error;

                if( level !== '')
                	errorElem.classList.add(level);
        },

        clearError: function() {
            unCodes.errorHTML('', '');
            $('.modal-content').find('input').each( function(i,v){
            	$(v).removeClass('error');
            });
            $('.modal-content').find('select').each( function(i,v){
            	$(v).removeClass('error');
            });
            $('#modal-error').addClass('hidden');
        },

		addUnCodes: function(modal_dataset, args) {
			var btnCta 		= document.getElementById('modal-btn-cta');
			var inputData 	= getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'un_codes',
				method		: 'add',
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,

				beforeSend: function() {
					//throbber(btnCta);
					disable_button(btnCta, true);
				},
				success: function(data) {

					if (data.success) {
						unCodes.clearError();
						//unCodes.errorHTML(data.message, data.level);
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}

					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');

					disable_button(btnCta, false);
				}
			});
		},

		editUnCodes: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');
			var inputData = getInputFieldVals('.input-wrapper');
			var settings = {
				apiclass	: 'un_codes',
				method		: 'edit',
				action		: args.action,
				tid 		: args.tid
			}
			$.extend(settings, inputData);


			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						unCodes.clearError();

						if( args.reload ) {
							location.reload();
						}

						// REGENERATE THE FIELD VALUES
						if( data.term ) {
							$('#port-code').val(data.term.code);
							$('#port-name').val(data.term.name);
							$('#port-country').val(data.term.country).attr("selected", "selected");
						}

						// TRIGGER UPDATE BUTTON
						$('#modal-btn-cta').click(function(e){
							e.preventDefault();

							unCodes.editUnCodes(
								modal_dataset,
								{
									tid 	: args.tid,
									action 	: 'update',
									reload 	: true,
								}
							);
						});

						$('#anchorModal').find('.modal-close').click(function(){
							location.reload();
						});
					}
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		deleteUnCodes: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'un_codes',
				method		: 'delete',
				tid 		: args.tid
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},
	}

	window.hsCodes = {
		addHsCodesHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Add new HS Code</h2>';
				html += '<p id="modal-error"></p>';
				html += '<div class="input-wrapper form-item">';
				html += '<label for="hscode-name">Enter full HS Code <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="hscode-name" class="form-text">';
				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Add</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		editHsCodesHTML: function() {
			var obj = {};
			var html = '<h2>Edit HS Code</h2>';
				html += '<p id="modal-error"></p>';
				html += '<div class="input-wrapper form-item">';
				html += '<label for="hscode-name">Enter full HS Code <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="hscode-name" class="form-text">';
				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Update</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		deleteHsCodesHTML: function() {
			var obj = {};
			var html = '<h2>Delete HS Code</h2>';
				html += '<p id="modal-error"></p>';
				html += '<p>Are you sure you want to delete this HS Code?</p>';
				html += '<button id="modal-btn-cancel" class="btn">Cancel</button>';
				html += '<button id="modal-btn-cta" class="btn">Delete</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		addHsCodes: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'hs_codes',
				method		: 'add',
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,

				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {

					if (data.success) {
						unCodes.clearError();
						//unCodes.errorHTML(data.message, data.level);
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		editHsCodes: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'hs_codes',
				method		: 'edit',
				action		: args.action,
				tid 		: args.tid
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						unCodes.clearError();

						if( args.reload ) {
							location.reload();
						}

						// REGENERATE THE FIELD VALUES
						if( data.term ) {
							$('#hscode-name').val(data.term.name);
						}

						// TRIGGER UPDATE BUTTON
						$('#modal-btn-cta').click(function(e){
							e.preventDefault();

							hsCodes.editHsCodes(
								modal_dataset,
								{
									tid 	: args.tid,
									action 	: 'update',
									reload 	: true,
								}
							);
						});

						$('#anchorModal').find('.modal-close').click(function(){
							location.reload();
						});
					}
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}

					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		deleteHsCodes: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'hs_codes',
				method		: 'delete',
				tid 		: args.tid
			}

			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},
	}

	window.shippingLine = {
		addShippingLineHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Add new Shipping Line</h2>';
				html += '<p id="modal-error"></p>';
				html += '<div class="input-wrapper form-item">';
				html += '<label for="shipping-line-code">Enter Shipping Line Code <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="shipping-line-code" class="form-text">';
				html += '<label for="shipping-line-name">Enter Shipping Line name <span class="form-required" title="This field is required.">*</span></label>';
				html += '<textarea id="shipping-line-name" name="description"></textarea>';
				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Add</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		editShippingLineHTML: function() {
			var obj = {};
			var html = '<h2>Edit Shipping Line</h2>';
				html += '<p id="modal-error"></p>';
				html += '<div class="input-wrapper form-item">';
				html += '<label for="shipping-line-code">Enter Shipping Line Code <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="shipping-line-code" class="form-text">';
				html += '<label for="shipping-line-name">Enter Shipping Line name</label>';
				html += '<textarea id="shipping-line-name" name="description"></textarea>';
				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Update</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		deleteShippingLineHTML: function() {
			var obj = {};
			var html = '<h2>Delete Shipping Line</h2>';
				html += '<p id="modal-error"></p>';
				html += '<p>Are you sure you want to delete this Shipping Line?</p>';
				html += '<button id="modal-btn-cancel" class="btn">Cancel</button>';
				html += '<button id="modal-btn-cta" class="btn">Delete</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		addShippingLine: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'shipping_line',
				method		: 'add',
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,

				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {

					if (data.success) {
						unCodes.clearError();
						//unCodes.errorHTML(data.message, data.level);
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		editShippingLine: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'shipping_line',
				method		: 'edit',
				action		: args.action,
				tid 		: args.tid
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						unCodes.clearError();

						if( args.reload ) {
							location.reload();
						}

						// REGENERATE THE FIELD VALUES
						if( data.term ) {
							$('#shipping-line-code').val(data.term.code);
							$('#shipping-line-name').val(data.term.name);
						}

						// TRIGGER UPDATE BUTTON
						$('#modal-btn-cta').click(function(e){
							e.preventDefault();

							shippingLine.editShippingLine(
								modal_dataset,
								{
									tid 	: args.tid,
									action 	: 'update',
									reload 	: true,
								}
							);
						});

						$('#anchorModal').find('.modal-close').click(function(){
							location.reload();
						});
					}
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		deleteShippingLine: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'shipping_line',
				method		: 'delete',
				tid 		: args.tid
			}

			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},
	}

	window.releaseDepots = {
		addReleaseDepotsHTML: function() {
			var obj = {};
			var html = '<h2>Add new release depot</h2>';
				html += '<p id="modal-error"></p>';
				html += '<div class="input-wrapper form-item">';
				html += '<label for="release-depot-code">Release depot code <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="release-depot-code">';
				html += '<label for="release-depot-name">Release depot name <span class="form-required" title="This field is required.">*</span></label>';
				html += '<textarea id="release-depot-name"></textarea>';
				html += '<label for="release-depot-location">Location <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="release-depot-location">';
				html += '<label for="release-depot-address">Address <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="release-depot-address">';
				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Add</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		editReleaseDepotsHTML: function() {
			var obj = {};
			var html = '';
				html += '<h2>Update release depot</h2>';
				html += '<p id="modal-error"></p>';
				html += '<div class="input-wrapper form-item">';
				html += '<label for="release-depot-code">Release depot code <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="release-depot-code">';
				html += '<label for="release-depot-name">Release depot name <span class="form-required" title="This field is required.">*</span></label>';
				html += '<textarea id="release-depot-name"></textarea>';
				html += '<label for="release-depot-location">Location <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="release-depot-location">';
				html += '<label for="release-depot-address">Address <span class="form-required" title="This field is required.">*</span></label>';
				html += '<input id="release-depot-address">';
				html += '</div>';
				html += '<button id="modal-btn-cta" class="btn">Update</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		deleteReleaseDepotsHTML: function() {
			var obj = {};
			var html = '<h2>Delete release depot</h2>';
				html += '<p>Are you sure you want to delete this release depot?</p>';
				html += '<button id="modal-btn-cancel" class="btn">Cancel</button>';
				html += '<button id="modal-btn-cta" class="btn">Delete</button>';

			obj.output = html;
			obj.btn_id = 'modal-btn-cta'; // Activate callback
			return obj;
		},

		addReleaseDepots: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'release_depot',
				method		: 'add',
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,

				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {

					if (data.success) {
						unCodes.clearError();
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}

					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		editReleaseDepots: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'release_depot',
				method		: 'edit',
				action		: args.action,
				tid 		: args.tid
			}
			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						unCodes.clearError();

						if( args.reload ) {
							location.reload();
						}

						// REGENERATE THE FIELD VALUES
						if( data.term ) {
							$('#release-depot-code').val(data.term.code);
							$('#release-depot-name').val(data.term.name);
							$('#release-depot-location').val(data.term.location);
							$('#release-depot-address').val(data.term.address);
						}

						// TRIGGER UPDATE BUTTON
						$('#modal-btn-cta').click(function(e){
							e.preventDefault();

							releaseDepots.editReleaseDepots(
								modal_dataset,
								{
									tid 	: args.tid,
									action 	: 'update',
									reload 	: true,
								}
							);
						});

						$('#anchorModal').find('.modal-close').click(function(){
							location.reload();
						});
					}
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}

					if (data.invalid) {
						invalidFields(data.invalid);
					}

					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},

		deleteReleaseDepots: function(modal_dataset, args) {
			var btnCta = document.getElementById('modal-btn-cta');

			var inputData = getInputFieldVals('.input-wrapper');

			var settings = {
				apiclass	: 'release_depot',
				method		: 'delete',
				tid 		: args.tid
			}

			$.extend(settings, inputData);

			$().customAjax({
				TYPE: "POST",
				AJAX_URL: Drupal.settings.basePath + "anchor/api",
				POST_STRING: settings,
				beforeSend: function() {
					disable_button(btnCta, true);
				},
				success: function(data) {
					if (data.success) {
						location.reload();
					}

					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
					}
					disable_button(btnCta, false);
				},
				error: function(data) {
					if (data.error) {
						unCodes.errorHTML(data.error, data.level);
						return;
					}
					unCodes.errorHTML('There was a data error when trying to connect.', 'fatal');
					disable_button(btnCta, false);
				}
			});
		},
	}


	window.getInputFieldVals = function(elem) {
		var inputs = {};

		$(elem).find('input').each(function(i, v) {
			inputs[$(v).attr('id')] = $(v).val();
		});

		$(elem).find('select').each(function(i, v) {
			inputs[$(v).attr('id')] = $(v).val();
		});

		$(elem).find('textarea').each(function(i, v) {
			inputs[$(v).attr('id')] = $(v).val();
		});

		return inputs;
	}


	window.invalidFields = function(fields) {
        for (var i in fields) {
            if (!fields[i].valid) {
                $('#' + i).addClass('error');
            } else {
                $('#' + i).removeClass('error');
            }
        }
    }

})(jQuery, Drupal)
